<template>
  <div class="crud-container">


    <!-- Create/Edit Dialog -->
    <div v-if="dialog" class="dialog">
      <div class="dialog-content">
        <h3>{{ isEdit ? 'Edit Item' : 'Create Item' }}</h3>
        <label>
          First Name
          <input v-model="itemForm.name" />
        </label>
        <label>
          Last Name
          <input v-model="itemForm.lastName" />
        </label>
        <label>
          Mail
          <input v-model="itemForm.mail" />
        </label>
        <label>
          Invoice Address 1
          <input v-model="itemForm.invoiceAddress" />
        </label>
        <label>
          Invoice Address 2
          <input v-model="itemForm.invoiceAddress" />
        </label>
        <label>
          Invoice Mail
          <input v-model="itemForm.invoiceMail" />
        </label>
        <label>
          Invoice Mobile
          <input v-model="itemForm.invoiceMobile" />
        </label>
        <div class="dialog-actions">

          <router-link to="/admin/about-me"><button @click="dialog = false"
              class="cancel-btn">Cancel</button></router-link>
          <button @click="saveItem" class="save-btn">{{ isEdit ? 'Save' : 'Create' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';
import instance from '@/axios'
import { useAuthStore } from '@/stores/authStore'
import { useRouter } from 'vue-router'


export default defineComponent({
  setup() {
    const items = ref<any[]>([]);
    const dialog = ref(true);
    const isEdit = ref(true);
    const authStore = useAuthStore()
    const router = useRouter()
    const itemForm = ref({
      _id: 0,
      name: '',
      lastName: '',
      mail: '',
      invoiceAddress: '',
      invoiceAddress1: '',
      invoiceMail: '',
      invoiceMobile: '',
      password: '',
      panNumber: '',
      gstNumber: ''
    });

    const fetchItems = async () => {
      // Simulate API call to get data
      const response = await instance.get('/users/' + authStore?.getUserData?.id)

      items.value = response.data.Result
    };

    const openEditDialog = (item: any) => {
      isEdit.value = true;
      itemForm.value = { ...item };
      dialog.value = true;
    };

    const saveItem = async () => {
      if (isEdit.value) {
        // Update item in items
        const index = items.value.findIndex((item) => item._id === itemForm.value._id);
        if (index !== -1) {
          items.value[index] = itemForm.value;
          await instance.put('/users', itemForm.value)
          router.push('/admin/about-me')
        }
      }
    };

    onMounted(async () => {
      await fetchItems();
      await openEditDialog(items.value[0]);
    });

    return {
      items,
      dialog,
      isEdit,
      itemForm,
      openEditDialog,
      saveItem,
    };
  },
  });
  </script>

<style scoped>
.crud-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.create-btn {
  padding: 10px 20px;
  background-color: #4caf50;
  color: white;
  border: none;
  cursor: pointer;
  margin-bottom: 20px;
}

.create-btn:hover {
  background-color: #45a049;
}

.crud-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.crud-table th,
.crud-table td {
  padding: 10px;
  text-align: left;
  border: 1px solid #ddd;
}

.crud-table th {
  background-color: #f4f4f4;
}

.edit-btn,
.delete-btn {
  padding: 5px 10px;
  margin: 0 5px;
  cursor: pointer;
}

.edit-btn {
  background-color: #ffa500;
  color: white;
  border: none;
}

.delete-btn {
  background-color: #f44336;
  color: white;
  border: none;
}

.edit-btn:hover {
  background-color: #e68a00;
}

.delete-btn:hover {
  background-color: #e03131;
}

.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  width: 400px;
  /* Make the dialog content scrollable */
  max-height: 85%;
  /* Define the max height for the dialog box */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

.dialog-actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.dialog input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.cancel-btn,
.save-btn {
  padding: 8px 15px;
  background-color: #2196f3;
  color: white;
  border: none;
  cursor: pointer;
}

.cancel-btn:hover {
  background-color: #1e88e5;
}

.save-btn {
  background-color: #4caf50;
}

.save-btn:hover {
  background-color: #45a049;
  }
  
</style>
  
